
import React from 'react';
import { Button } from '@/components/ui/button';

const CallToAction = () => {
  return (
    <section className="bg-directpress-dark py-16 md:py-20">
      <div className="container mx-auto px-4 md:px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 max-w-3xl mx-auto">
          Join the Revolution in Journalism Today
        </h2>
        <p className="text-lg text-white/80 mb-8 max-w-2xl mx-auto">
          Whether you're a passionate journalist looking for independence or a reader seeking authentic voices, DirectPress is building the future of news.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Button className="bg-directpress-orange hover:bg-orange-600 text-white px-8 py-6 text-lg">
            Start Writing
          </Button>
          <Button className="bg-white text-directpress-dark font-medium hover:bg-gray-100 px-8 py-6 text-lg">
            Start Reading
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
